import {IAsyncData, IDealerInfo} from '@signal/asp-data-commons';
import * as fromActions from './dealer.actions';
import produce from 'immer';
import { StateDetails } from '../../shared/models/state';

export function dealerReducer(
  state: DealerState = initialState,
  action: fromActions.DealerType): DealerState {

  switch (action.type) {
    case fromActions.DealerTypes.LOAD_DEALER_DETAILS: {
      return produce(state, draftState => {
        draftState.dealerInfo = {
          data: null,
          loading: true,
          loaded: false,
          error: ''
        };
      });
    }

    case fromActions.DealerTypes.LOAD_DEALER_DETAILS_SUCCESS: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.LoadDealerDetailsSuccess ? action.payload : undefined;
        draftState.dealerInfo = {
          data: payload.dealerInfo,
          loading: true,
          loaded: false,
          error: ''
        };
      });
    }

    case fromActions.DealerTypes.LOAD_DEALER_DETAILS_FAILURE: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.LoadDealerDetailsFail ? action.payload : undefined;
        draftState.dealerInfo = {
          data: {} as IDealerInfo,
          loading: true,
          loaded: false,
          error: payload.error
        };
      });
    }

    case fromActions.DealerTypes.LOAD_STATES: {
      return produce(state, draftState => {
        draftState.states = {
          data: [],
          loading: true,
          loaded: false,
          error: ''
        };
      });
    }
    case fromActions.DealerTypes.LOAD_DASHBOARD_CONTENTS: {
      return produce(state, draftState => {
        draftState.states = {
          data: [],
          loading: true,
          loaded: false,
          error: ''
        };
      });
    }
    case fromActions.DealerTypes.LOAD_DASHBOARD_CONTENTS_SUCCESS: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.LoadDashboardOverlayContentsSuccess ? action.payload : undefined;
        draftState.contents = {
          data: payload.contents,
          loading: true,
          loaded: false,
          error: ''
        };
      });
    }
    case fromActions.DealerTypes.LOAD_DASHBOARD_CONTENTS_FAILURE: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.LoadDashboardOverlayContentsFailure ? action.payload : undefined;
        draftState.contents = {
          data: [],
          loading: true,
          loaded: false,
          error: payload.error
        };
      });
    }

    case fromActions.DealerTypes.LOAD_STATES_SUCCESS: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.LoadStatesDetailsSuccess ? action.payload : undefined;
        draftState.states = {
          data: payload.states,
          loading: true,
          loaded: false,
          error: ''
        };
      });
    }

    case fromActions.DealerTypes.LOAD_STATES_FAILURE: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.LoadStatesDetailsFail ? action.payload : undefined;
        draftState.states = {
          data: [],
          loading: true,
          loaded: false,
          error: payload.error
        };
      });
    }

    case fromActions.DealerTypes.LOAD_CITIES: {
      return produce(state, draftState => {
        draftState.cities = {
          data: {},
          loading: true,
          loaded: false,
          error: ''
        };
      });
    }

    case fromActions.DealerTypes.LOAD_CITIES_SUCCESS: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.LoadCityDetailsSuccess ? action.payload : undefined;
        draftState.cities = {
          data: payload.cities,
          loading: true,
          loaded: false,
          error: ''
        };
      });
    }

    case fromActions.DealerTypes.LOAD_CITIES_FAILURE: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.LoadCityDetailsFail ? action.payload : undefined;
        draftState.cities = {
          data: {},
          loading: true,
          loaded: false,
          error: payload.error
        };
      });
    }

    default:
      return state;
  }

}

const initialState = {
  dealerInfo: {
    data: null,
    loading: false,
    loaded: false,
    error: ''
  },
  states: {
    data: null,
    loading: false,
    loaded: false,
    error: ''
  },
  cities: {
    data: null,
    loading: false,
    loaded: false,
    error: ''
  },
  contents: {
    data: null,
    loading: false,
    loaded: false,
    error: ''
  }
};

export interface DealerState {
  dealerInfo: IAsyncData<IDealerInfo>;
  states: IAsyncData<StateDetails[]>;
  cities: IAsyncData<{ [key: string]: string[] }>;
  contents: IAsyncData<any[]>;
}
